import { hexToRgb, toCssRgb } from "@/utils/color.util";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const matchMedia = gsap.matchMedia();

const colorsBase = {
    light: "#EE2D43",
    base: "#D61772",
};

const medias = {
    isMobile: "(max-width: 767px)",
    isDesktop: "(min-width: 768px)",
};

export const animateBackground = (colors) => {
    const light = hexToRgb(colors.light);
    const base = hexToRgb(colors.base);
    const backgroundImage = `
            radial-gradient(
                circle farthest-corner at top left,
                ${toCssRgb(light)} 0%,
                ${toCssRgb(base)} 100%
            )
        `;

    gsap.killTweensOf(document.body);
    gsap.to(document.body, {
        backgroundImage,
        duration: 0.45,
        ease: "power2",
    });
};

export const scroll = (
    id,
    trigger,
    colors = colorsBase,
    { desktop, mobile } = {}
) => {
    matchMedia.add(medias, (context) => {
        const { isDesktop, isMobile } = context.conditions;

        clearScroll(id);

        ScrollTrigger.create({
            id,
            trigger,
            start: isMobile ? "top 50%" : "top 60%",
            end: isMobile ? "bottom 50%" : "bottom 60%",
            onEnter: () => {
                animateBackground(colors);
                isDesktop && desktop !== undefined && desktop.show();
                isMobile && mobile !== undefined && mobile.show();
            },
            onEnterBack: () => {
                animateBackground(colors);
                isDesktop && desktop !== undefined && desktop.show();
                isMobile && mobile !== undefined && mobile.show();
            },
            onLeave: () => {
                isDesktop && desktop !== undefined && desktop.hide();
                isMobile && mobile !== undefined && mobile.hide();
            },
            onLeaveBack: () => {
                isDesktop && desktop !== undefined && desktop.hide();
                isMobile && mobile !== undefined && mobile.hideBack();
            },
        });

        return () => {
            clearScroll(id);
        };
    });
};

export const scrollBatch = (id, triggers) => {
    matchMedia.add(medias, (context) => {
        const { isMobile } = context.conditions;

        if (isMobile) return;

        const onEnter = (elements) => {
            gsap.to(elements, { opacity: 1, y: 0, stagger: 0.02 });
        };
        const onLeave = (elements) => {
            gsap.to(elements, { opacity: 0, y: "-5%", stagger: 0.02 });
        };
        const onLeaveBack = (elements) => {
            gsap.to(elements, { opacity: 0, y: "5%", stagger: 0.02 });
        };

        clearScroll(id);

        ScrollTrigger.batch(triggers, {
            id,
            onEnter,
            onEnterBack: onEnter,
            onLeave,
            onLeaveBack,
        });

        return () => {
            clearScroll(id);
        };
    });
};

export const clearScroll = (id) => {
    const scroll = ScrollTrigger.getById(id);
    if (scroll) {
        scroll.kill();
    }
};
